import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Image from '../../../../assets/images/engage/engage-second.png';

const EngageSecondSection = () => {
  return (
    <section className="engagesecond">
      <Container fluid="lg">
        <Row className="engagesecond__row">
          <Col className="engagesecond__header">
            <h1 className="title-md-section">
              met<span className="title-md-cursive-section">amor</span>fosis
            </h1>
          </Col>
          <Col className="engagesecond__text">
            <p className="phrase">
              Es fascinante conocer el cuerpo cíclico y danzar al ritmo de sus cambios.
            </p>
            <p className="phrase">
              Vivimos más tiempo, pero no todas danzamos hacia la longevidad en equidad y dignidad.
            </p>
            <p className="phrase">
              {' '}
              Habitar este tiempo pide consciencia, cuidado, agencia y responsabilidad institucional y colectiva para la <span>calidad de vida y el placer</span> de todas.
            </p>
            <p className="phrase fw-bold mt-3">Carolina A.</p>
          </Col>
          <Col className="engagesecond__imageBox">
            <img
              src={Image}
              alt="Ilustración de la agenda Mujer Sin Reglas 2024"
              className="image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EngageSecondSection;
